"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ykbUtils = require("ykb-utils");
var _Iban = _interopRequireDefault(require("../../Iban"));
var currency = function currency(_ref) {
  var currencyType = _ref.currencyType,
    currencyPrecision = _ref.currencyPrecision,
    allowEmpty = _ref.allowEmpty,
    removeTrailingZeros = _ref.removeTrailingZeros;
  return function (value) {
    var __value = _ykbUtils.excelExportFormatter.currency({
      value: value,
      currencyType: currencyType,
      currencyPrecision: currencyPrecision,
      allowEmpty: allowEmpty,
      removeTrailingZeros: removeTrailingZeros
    });
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-currency-field"
    }, __value);
  };
};
var number = function number() {
  return function (value) {
    var __value = _ykbUtils.excelExportFormatter.number(value);
    if ((0, _ykbUtils.isNullOrUndefined)(__value)) return null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-table-number-field"
    }, __value, " ");
  };
};
var iban = function iban() {
  return function (value) {
    if (value && value.length === 26) return /*#__PURE__*/_react.default.createElement(_Iban.default, {
      value: value
    });
    return value;
  };
};
var moment = function moment(_ref2) {
  var format = _ref2.format;
  return function (value) {
    var date = _ykbUtils.excelExportFormatter.date(value, format);
    if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-table-date-field"
    }, date);
  };
};
var date = function date(_ref3) {
  var format = _ref3.format;
  return function (value) {
    var date = _ykbUtils.excelExportFormatter.date(value, format);
    if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-table-date-field"
    }, date);
  };
};
var datetime = function datetime(_ref4) {
  var format = _ref4.format;
  return function (value) {
    var date = _ykbUtils.excelExportFormatter.date(value, format);
    if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-table-date-time-field"
    }, date);
  };
};
var jsondate = function jsondate(_ref5) {
  var format = _ref5.format;
  return function (value) {
    var date = _ykbUtils.excelExportFormatter.jsondate(value, format);
    if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-table-date-time-field"
    }, date);
  };
};
var timestamp = function timestamp(_ref6) {
  var format = _ref6.format;
  return function (value) {
    var date = _ykbUtils.excelExportFormatter.timestamp(value, format);
    if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-table-date-time-field"
    }, date);
  };
};
var time = function time(_ref7) {
  var format = _ref7.format;
  return function (value) {
    var date = _ykbUtils.excelExportFormatter.time(value, format);
    if ((0, _ykbUtils.isNullOrUndefined)(date)) return null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "ykb-table-date-time-field"
    }, date, " ");
  };
};
var edit = function edit(value, row, index, locale, type) {
  var tooltipProps = type.tooltipProps || {};
  if (type.disabled === true || type.buttonProps && type.buttonProps.disabled) {
    tooltipProps.visible = false;
  }
  return /*#__PURE__*/_react.default.createElement(Tooltip, (0, _extends2.default)({
    placement: "top",
    overlay: type.title || locale.edit
  }, tooltipProps), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Icon, {
    name: "edit",
    colorType: "primary",
    size: 24
  })));
};
var detail = function detail(value, row, index, locale, type) {
  var tooltipProps = type.tooltipProps || {};
  if (type.disabled || type.buttonProps && type.buttonProps.disabled) {
    tooltipProps.visible = false;
  }
  return /*#__PURE__*/_react.default.createElement(Tooltip, (0, _extends2.default)({
    placement: "top",
    overlay: type.title || locale.detail
  }, tooltipProps), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Icon, {
    name: "search",
    colorType: "primary",
    size: 24
  })));
};
var _delete = function _delete(value, row, index, locale, type) {
  var tooltipProps = type.tooltipProps || {};
  if (type.disabled || type.buttonProps && type.buttonProps.disabled) {
    tooltipProps.visible = false;
  }
  return /*#__PURE__*/_react.default.createElement(Tooltip, (0, _extends2.default)({
    placement: "top",
    overlay: type.title || locale.delete
  }, tooltipProps), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Icon, {
    name: "trash",
    colorType: "default",
    size: 24
  })));
};
var _default = exports.default = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
  currency: currency,
  number: number,
  iban: iban,
  moment: moment,
  date: date,
  datetime: datetime,
  jsondate: jsondate,
  timestamp: timestamp,
  time: time,
  edit: edit
}, "edit", edit), "detail", detail), "delete", _delete);